// In your slice file, e.g., RateSummary.ts

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '@Services/apiAxios';

export const downloadRateSheet = createAsyncThunk<
  string, // Return type: URL string
  {
    rateParams: any;
    accountNumber: string | null;
  },
  { rejectValue: string }
>('rateSummary/downloadRateSheet', async ({ rateParams, accountNumber }, { rejectWithValue }) => {
  try {
    const searchParams = new URLSearchParams();
    searchParams.append('sheet', encodeURIComponent(JSON.stringify(rateParams)));
    const searchParamsStr = '?' + searchParams.toString();
    const result = await API.get('/shipment/download/rate/' + accountNumber + searchParamsStr);
    return result.data;
  } catch (error: any) {
    console.error(error);
    return rejectWithValue(error?.message || 'Download failed');
  }
});

interface RateSummaryState {
  downloadStatus: 'idle' | 'loading' | 'succeeded' | 'failed';
  downloadError: string | null;
  downloadUrl: string;
}

const initialState: RateSummaryState = {
  downloadStatus: 'idle',
  downloadError: null,
  downloadUrl: '',
};

const rateSummarySlice = createSlice({
  name: 'rateSummary',
  initialState,
  reducers: {
    resetDownload(state) {
      state.downloadStatus = 'idle';
      state.downloadError = null;
      state.downloadUrl = '';
    },
    // other reducers...
  },
  extraReducers: builder => {
    builder
      .addCase(downloadRateSheet.pending, state => {
        state.downloadStatus = 'loading';
        state.downloadError = null;
      })
      .addCase(downloadRateSheet.fulfilled, (state, action) => {
        state.downloadStatus = 'succeeded';
        state.downloadUrl = action.payload;
      })
      .addCase(downloadRateSheet.rejected, (state, action) => {
        state.downloadStatus = 'failed';
        state.downloadError = action.payload || 'Something went wrong';
        state.downloadUrl = '';
      });
  },
});

export const { resetDownload } = rateSummarySlice.actions;
export default rateSummarySlice.reducer;
